/*
 * This file is generated by the workex CLI Tool
 *
 * Please visit https://workex.pistonite.dev for more information
 */

import type { WxProtocolBindConfig } from "@pistonite/workex";
import type { PrismApi } from "../proto.ts";
import { _wxSenderImpl, _wxRecverImpl } from "./PrismApi.ts";

/**
 * Create a bind config for the PrismApi interface, under the `prism` protocol
 *
 * When used with a creator function in Workex, if no arguments, or a `resolve` function is provided,
 * the config will be for the sender side (i.e. the side that calls PrismApi).
 * Otherwise, the config will be for the receiver side, and an implementation of PrismApi needs to be provided.
 *
 * This interface is not linked to another interface in the protocol. One side should provide an implementation, and the other
 * side should call with no arguments or a `resolve` function to receive a caller.
 *
 * This function is generated by the workex CLI tool
 */
export function bindPrismApi(handler: PrismApi): WxProtocolBindConfig<Record<string, never>>;
export function bindPrismApi(resolve?: (_: PrismApi) => (void | Promise<void>)): WxProtocolBindConfig<PrismApi>;
export function bindPrismApi(handlerOrResolve?: PrismApi | ((_: PrismApi) => (void | Promise<void>))): WxProtocolBindConfig<Record<string, never>> | WxProtocolBindConfig<PrismApi> {
    if (!handlerOrResolve || typeof handlerOrResolve === "function") { return {
        protocol: "prism",
        interfaces: ["PrismApi", "_wxStub"],
        recvHandler: () => Promise.resolve({ err: { code: "UnexpectedStubCall" } }),
        bindSend: (sender) => {
            const impl = new _wxSenderImpl(sender);
            handlerOrResolve?.(impl);
            return impl;
        },
    };}
    return {
        protocol: "prism",
        interfaces: ["_wxStub", "PrismApi"],
        recvHandler: _wxRecverImpl(handlerOrResolve),
        bindSend: () => ({})
    };
};